<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <th>Info</th>
          <th>New/changed vars</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(f, index) in value" :key="index">
          <td>{{ f.Info }}</td>
          <td>
            <FieldValueList :value="f.VarsChanged" />
          </td>
          <td>
            <span class="badge bg-dark text-light">{{ f.field }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import FieldValueList from "../components/FieldValueList";
export default {
  components: {
    FieldValueList,
  },
  props: {
    value: Array,
  },
};
</script>

<style scoped>
.badge {
  font-size: 1.1em;
}
</style>